function AboutUs() {
  return (
    <main>
      <header>
        <h1>About Us</h1>
      </header>
      <section className="about-us">
        <div className="info">
          <div className="row">
            <span>Project Type</span>
            <span>Small and medium sized enterprise</span>
          </div>
          <div className="row">
            <span>Project Name</span>
            <span>The Usage of Multipurpose Tasks in Maritime</span>
          </div>
          <div className="row">
            <span>Project Number</span>
            <span>2022-1-TR01-KA220-VET-000089562</span>
          </div>
          <div className="row">
            <span>Project Budget</span>
            <span>250.000€</span>
          </div>
          <div className="row">
            <span>Project Duration</span>
            <span>2 years</span>
          </div>
          <div className="row">
            <span>Coordinator</span>
            <span>
              Gölcük Şehit Volkan Tantürk Mesleki ve Teknik Anadolu Lisesi{" "}
              <span>Turkiye</span>
            </span>
          </div>
          <div className="row">
            <span>Project Partners</span>
            <ul>
              <li>
                Nikola Vaptsarov Naval Academy <span>Bulgaria</span>
              </li>
              <li>
                {" "}
                Sea Teach S.L. <span>Spain</span>
              </li>
              <li>
                LudusXR Aps <span>Denmark</span>
              </li>
              <li>
                Sveuciliste U Rijeci <span>Croatia</span>
              </li>
              <li>
                {" "}
                Second Epal Neas Ionias <span>Greece</span>
              </li>
              <li>
                {" "}
                Limon Teknoloji Yazılım ve Donanım Tic.Ltd.Şti.{" "}
                <span>Turkiye</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="summary">
          <p>
            Küresel ekonomik gelişim dünya ticaretini hızla geliştirmektedir.
            Dünya ticaretinin çok önemli bir kısmı deniz yolu ile
            gerçekleştirilmekte, dünya ve deniz ticaretindeki gelişmeler
            birbirine paralel gitmektedir. Ülke ekonomileri giderek artan bir
            biçimde etkin bir deniz ulaşımına bağımlı olmaktadır. Bu durum
            ülkelerin deniz ticaret filolarını güçlendirmeye yönlendirmekte ve
            bu alanda yetişmiş insan gücü açığı meydana getirmektedir. Özellikle
            gemi makinaları ve bakımı, yüksek maliyetleri ve uzmanlık gerektiren
            iş gücü gereksinimi nedeniyle bu alanda en çok istihdam açığı
            bulunan bölüm olmaktadır. Geminin kalbi noktasında olan ve meydana
            gelen arızaların gemi rotasında meydana getireceği gecikmeler ve
            bundan kaynaklı ödenen yüksek tazminatlar bu alanı oldukça değerli
            kılmaktadır.
          </p>
          <p>
            Gemi makinaları alanındaki iş gücü ihtiyacını karşılama ; bu
            alanlara yönelik eğitim yatırımları ve gemi makinaları alanında
            yetişen öğrencilere verilecek yetkin bir eğitim ile mümkün
            olacaktır.
          </p>
          <p>
            Mesleki eğitim veren okullarda öğrenim gören çocuklar için daha
            aktif rol almalarını sağlayacak çevrimiçi kaynaklar sunulmalıdır.
            Proje ortaklarımız tarafından gerçek zamanlı interaktif bir
            laboratuvar simülasyon programı geliştirilecektir. Bu programda
            uygulama simülasyonu, teoriler, prosedürler ve öğrenci gözlemlerinin
            not alınabileceği alanlar bulunmaktadır. Simülasyon ortak atölye
            materyallerini içerecektir.
          </p>
          <p>
            Denizcilik sektörünün gemi makinaları alanında oluşturulacak dijital
            eğitim içerikleri ile mesleki eğitimin uzaktan eğitim modellerinde
            sürdürülebilirliğini sağlanacak, koçluk desteği sağlanabilecek, ders
            içi deney ve uygulamalı projeler gibi etkileşimli bir ortam
            oluşturulabilecek, bireysel izleme ile başarı arttırılacak ve
            uzaktan mesleki eğitimde öğrenci merkezli bir eğitim süreci
            sağlanabilecektir. Bu kapsamda yapılan ihtiyaç analizleri
            doğrultusunda denizicilik sektörü / gemi makinaları alanı
            öğrencileri hedef kitlemiz olarak belirlenmiştir. Elde edilecek
            eğitim içeriği dijital dönüşüm hazırlığı olacak ve bu alandaki
            eğitimler gemi makinaları kontrolü ve önleyici bakım hizmetleri
            noktasında büyük katkılar sunacaktır
          </p>
        </div>
      </section>
    </main>
  );
}

export default AboutUs;
